import { Input } from 'antd'
import styled from 'styled-components'
import { COLORS } from 'tokens'

export const InfoCard = styled.div`
  height: 128px;
  max-height: 128px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
`

export const InfoCardTitle = styled.span`
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 4px;
  margin-left: 17px;
`

export const InfoCardContent = styled.div`
  overflow-y: auto;
  width: 100%;
`

export const InfoCardText = styled.span<{ $bold?: boolean }>`
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: ${(props) => (props.$bold ? 'bold' : 'normal')};
  margin-bottom: 8px;
  margin-left: 16px;
`

export const SelectableOption = styled.div<{
  $selected: boolean
  $priority: number
  $disabled: boolean
}>`
  width: 100%;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  font-weight: ${(props) => (props.$priority === 1 ? 'bold' : 'normal')};
`

export const NotesInput = styled(Input.TextArea)`
  width: 100%;
  height: 128px !important;
  min-height: 128px;
  max-height: 128px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 8px;
  border: 1px solid ${COLORS.borderPrimary};
  background: var(--color-bg);
  color: var(--color-text-primary);
  font-size: 16px;
  padding: 16px;
  resize: none !important;
  line-height: 1.4;

  &::placeholder {
    color: var(--color-disabled);
  }
`
